import { merge } from "lodash-es";
import {
  type ChildMachineConfig,
  GenericChildState,
  ParentState,
} from "../../../types/common";
import { GuardTypes as ReviewGuardTypes } from "../Review/guards";
import { ActionTypes } from "./actions";
import { ContactEventType } from "./events";
import { GuardTypes } from "./guards";
import { ServiceTypes } from "./services";

export const getMachineState = (config: ChildMachineConfig) => ({
  id: ParentState.contactInformation,
  initial: GenericChildState.idle,
  always: {
    actions: ActionTypes.setContactVisited,
    cond: GuardTypes.notVisitedContact,
  },
  states: merge(
    {
      [GenericChildState.idle]: {},
      [GenericChildState.saving]: {
        invoke: {
          src: ServiceTypes.trackAddContactEvent,
          onDone: [
            {
              cond: ReviewGuardTypes.visitedReview,
              target: config.nextStateFromReview || ParentState.cartQuote,
            },
            {
              target: config.nextState || ParentState.passengerInformation,
            },
          ],
          onError: [
            {
              cond: ReviewGuardTypes.visitedReview,
              target: config.nextStateFromReview || ParentState.cartQuote,
            },
            {
              target: config.nextState || ParentState.passengerInformation,
            },
          ],
        },
      },
    },
    config.stateOverride
  ),
  on: {
    [ContactEventType.CHANGE]: {
      actions: ActionTypes.setContactInfo,
    },
    [ContactEventType.CHANGE_PHONE_NUMBER]: {
      actions: ActionTypes.setContactInfoPhoneNumber,
    },
    [ContactEventType.CHANGE_EMAIL]: {
      actions: ActionTypes.setContactInfoEmail,
    },
    [ContactEventType.NEXT]: `#${config.parentMachineId}.${ParentState.contactInformation}.${GenericChildState.saving}`,
  },
});
